import type { UnsubscribeCopy } from '../lib/communication'

/** The signed-out unsubscribe page's words (routes/Unsubscribe.tsx). Here, not in the route, so the suite can render it. */
export type UnsubscribePhase = 'ready' | 'busy' | 'done' | 'bad' | 'failed'

export function UnsubscribeBody({ t, phase, onConfirm }: { t: UnsubscribeCopy; phase: UnsubscribePhase; onConfirm: () => void }) {
  return (
    <>
      <h1 className="signin__title">{t.title}</h1>
      {phase === 'done' ? (
        <>
          <p className="signin__lede" role="status">{t.done}</p>
          <p className="signin__help">{t.doneNote}</p>
        </>
      ) : phase === 'bad' ? (
        <p className="signin__lede" role="alert">{t.bad}</p>
      ) : (
        <>
          <p className="signin__lede">{t.lead}</p>
          <button type="button" className="btn btn--primary" disabled={phase === 'busy'} onClick={onConfirm}>
            {t.button}
          </button>
          {phase === 'failed' && <p className="alert" role="alert">{t.failed}</p>}
        </>
      )}
    </>
  )
}

